import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Toaster } from '@/shared/components/ui/sonner'

const App = () => {
    return (
        <>
            <RouterProvider router={router} />
            <Toaster />
        </>
    )
}

export default App

